import { render } from "./InputCertifications.vue?vue&type=template&id=7cfd8d82"
import script from "./InputCertifications.vue?vue&type=script&lang=js"
export * from "./InputCertifications.vue?vue&type=script&lang=js"
script.render = render

export default script